module.exports = __webpack_public_path__ + "static/media/bg_mobile.c723cc18.svg";